export default "__VITE_ASSET__BHvj7l4D__"